import * as React from "react"
import { TransactionReconciliationStatus } from "@digits-graphql/frontend/graphql-bearer"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgClock } from "@digits-shared/components/SVGIcons/line/Clock.svg"
import { SvgShieldTick } from "@digits-shared/components/SVGIcons/line/ShieldTick.svg"
import { Select, SelectItem } from "@digits-shared/DesignSystem/FormElements/Selects/Select"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { BULK_FIELD_WIDTH } from "src/frontend/components/OS/Applications/Shared/Accounting/BulkActions/types"

const StyledSelect = styled(Select)`
  width: ${BULK_FIELD_WIDTH}px;
`

const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ReconciledIcon = styled(SvgShieldTick)`
  width: 18px;
  height: 18px;
  ${svgPathStyles(colors.primaryDark, 1.5)};
`

const UnsettledIcon = styled(SvgClock)`
  width: 18px;
  height: 18px;
  ${svgPathStyles(colors.accentYellow, 1.5)};
`

export const ReconciliationStatusSelect: React.FC<{
  status: TransactionReconciliationStatus | undefined
  setStatus: (status: TransactionReconciliationStatus) => void
  placeholder: string | undefined
  disabled: boolean
  customLabel?: string
}> = ({ status, setStatus, placeholder, disabled, customLabel }) => (
  <StyledSelect
    id="bulk-update-reconciliation-status-select"
    name="bulk-update-reconciliation-status-select"
    value={status}
    onValueChange={setStatus}
    placeholder={placeholder}
    disabled={disabled}
    label={customLabel ? customLabel : "Status"}
    small
  >
    <SelectItem value={TransactionReconciliationStatus.Reconciled}>
      <StatusInfo>
        <ReconciledIcon />
        Reconciled
      </StatusInfo>
    </SelectItem>

    <SelectItem value={TransactionReconciliationStatus.Unsettled}>
      <StatusInfo>
        <UnsettledIcon />
        Unsettled
      </StatusInfo>
    </SelectItem>
  </StyledSelect>
)
